declare namespace $ {

	export class $mol_icon_message extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=message.view.tree.d.ts.map